createPendingPromise